<script>
	import SearchForm from './SearchForm.svelte'
	import { onMount } from "svelte";
	import { formatNewEntries } from './js/localApiLookup.js';
	import { searchOptions } from './js/searchFunctions';
	import { core_site } from './js/mysite';

	async function newEntriesSearch() {
		const url = `${core_site}/gw2w/new?type=${searchOptions.searchType}&userOpts=${JSON.stringify(searchOptions)}`
		console.log(url);
		const res = await fetch(url);
		if (res.status !== 200) console.error(`Search lookup returned ${res.status}`);
		
		const data = await res.json();
		if (!data) {
			console.error('Error fetching search.');
			return;
		}
		return data;
	}

	async function getNewEntries(purge=false) {
		const newEntries = await newEntriesSearch();
		formatNewEntries(newEntries.foo, purge);
	}

	function disableSearchBar() {
		// I am a lazy pleb so we re-use and remove
		const search = document.getElementById('search');
		const parent = search.parentNode;
		const button = parent.getElementsByTagName('button')[0];

		parent.removeChild(search);
		parent.removeChild(button);
	}

	function updateNewEntries() {
		document.getElementById('searchResults').innerHTML = '';
		getNewEntries();
	}
	
	onMount( () => {
		// This is async but we don't actually care to block things
		getNewEntries()
		// Disable search details we don't want
		disableSearchBar();

		document.getElementById('search_type').addEventListener('change', updateNewEntries);
		document.getElementById('max_entries').addEventListener('change', updateNewEntries);
	});

</script>

<SearchForm searchOptions={searchOptions}/>
<queryResults>
	<div id='searchResults'>
	</div>
	<div id='infoboxes'>
	</div>
</queryResults>

<style>
	queryResults {
		width: 100%;
		display: block;
		margin-top: 5px;
	}

	#searchResults {
		float: left;
		padding-left: 1%;
		max-width: 30%;
		font-size: 20px;
	}

	#searchResults :global(div:hover) {
		background-color: rgba(0,0,0,0.1);
	}

	#infoboxes {
		float: right;
		text-align: left;
		width: 60%;
	}
</style>